import { render, staticRenderFns } from "./IviewRadioGroup.vue?vue&type=template&id=0f79a03b&scoped=true&"
import script from "./IviewRadioGroup.vue?vue&type=script&lang=js&"
export * from "./IviewRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./IviewRadioGroup.vue?vue&type=style&index=0&id=0f79a03b&prod&lang=less&"
import style1 from "./IviewRadioGroup.vue?vue&type=style&index=1&id=0f79a03b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f79a03b",
  null
  
)

export default component.exports